module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';

	var moment = require("moment"),
		hotelOffer = hotelOffers.at(0),
		touristGroup = hotelOffer.get('touristGroup'),
		discount = hotelOffer.get('discount'),
		resortName = resort instanceof Backbone.Model ? (resort.get('name') + ', ' + resort.get('country').get('name')) : (resort.name ? resort.name : '');

	require('moment/locale/ru');

__p+='\n<div class="serpHotelCard__container" data-sortrate="'+
((__t=( sortRate ))==null?'':__t)+
'">\n    ';
 if(isExclusive) { 
__p+='\n        <div class="js-serpHotelCard__isExclusive"></div>\n    ';
 } 
__p+='\n	<div class="serpHotelCard__carousel">\n		<div class="serpHotelCard__top-block">\n			<div>\n				';
 if(discount && discount > 0.1) { 
__p+='\n				<div class="serpHotelCard__discount">\n					Скидка - '+
((__t=( Math.round(discount*100) ))==null?'':__t)+
'%\n				</div>\n				';
 } 
__p+='\n				';
 if (hotelOffer.get('lessPlaces')) { 
__p+='\n				<div class="serpHotelCard__tip serpHotelCard__tip__less-places">Мало мест</div>\n				';
 } 
__p+='\n			</div>\n		</div>\n		<div class="serpHotelCard__carousel-container js-images-carousel">\n			<div class="newLoader"></div>\n			<ul class="list imagesHtml">'+
((__t=(imagesHtml?imagesHtml:''))==null?'':__t)+
'</ul>\n			<span class="js-images-carousel-control-prev serpHotelCard__carousel-prev"><i class="icon-i16_arrow_left_thin"></i></span>\n			<span class="js-images-carousel-control-next serpHotelCard__carousel-next"><i class="icon-i16_arrow_right_thin"></i></span>\n		</div>\n		';

		var distance,
			distanceCenter,
			title;

		if(distances.beach > 0) {
			if(distances.beach >= 1000) {
				distance = parseFloat((distances.beach/1000).toFixed(1)) + ' км';
			} else {
				distance = distances.beach + ' м';
			}
			title = 'до пляжа';

		} else if(distances.lift > 0) {
			if(distances.lift >= 1000) {
				distance = parseFloat((distances.lift/1000).toFixed(1)) + ' км';
			} else {
				distance = distances.lift + ' м';
			}
			title = 'до подъемника';
		}
		if(distances.center > 0) {
			if(distances.center >= 1000) {
				distanceCenter = parseFloat((distances.center/1000).toFixed(1)) + ' км';
			} else {
				distanceCenter = distances.center + ' м';
			}
		}

		if(distance || distanceCenter){ 
__p+='\n		<div class="serpHotelCard__distances">\n			';
 if(distanceCenter){ 
__p+='\n				<div class="serpHotelCard__distance">\n					<span>'+
((__t=(distanceCenter))==null?'':__t)+
'</span> до центра города\n				</div>\n			';
 }
			if(distance){ 
__p+='\n				<div class="serpHotelCard__distance">\n					<span>'+
((__t=(distance))==null?'':__t)+
'</span>'+
((__t=(title))==null?'':__t)+
'\n				</div>\n			';
 } 
__p+='\n			</div>\n		';
 }
__p+='\n	</div>\n	<div class="serpHotelCard__content">\n		<div class="serpHotelCard__left">\n			<div class="serpHotelCard__tips-wrap">\n			';
 if(rating > 0 || reviewsQty > 0 || hotelOffer.get('lessPlaces') || warranted){
__p+='\n				';
 if(rating > 0 || reviewsQty > 0 ){
__p+='\n				<div class="serpHotelCard__tips">\n					';
 if(rating > 0) {
						var ratingColorNumber = 0;
						rating = +rating.toFixed(1);
						if(rating >= 4.5){
							ratingColorNumber = 5;
						}else if(rating >= 4){
							ratingColorNumber = 4;
						}else if(rating >= 3.5){
							ratingColorNumber = 3;
						}
__p+='\n					<div class="serpHotelCard__tip serpHotelCard__rating ratingBgColor'+
((__t=(ratingColorNumber))==null?'':__t)+
'">\n						'+
((__t=( rating ))==null?'':__t)+
'\n					</div>\n					';
} if(reviewsQty > 0) { 
__p+='\n					<div class="serpHotelCard__tip serpHotelCard__review reviewBdColor'+
((__t=(ratingColorNumber))==null?'':__t)+
'">\n						<a href="#" class="goToHotel hotel-reviews">'+
((__t=(reviewsQty ))==null?'':__t)+
' отзыв'+
((__t=( reviewsQty.wordEnding(";а;ов") ))==null?'':__t)+
'</a>\n					</div>\n					';
 } 
__p+='\n				</div>\n				';
 } 
__p+='\n				';
 if (hotelOffer.get('lessPlaces')) { 
__p+='\n					<div class="serpHotelCard__tip serpHotelCard__tip__less-places">Мало мест</div>\n				';
 } 
__p+='\n				';
 if(warranted) { 
__p+='\n					<i class="icon-i16_check2 warranted-icon serpHotelCard__warranted js-warranted-icon"><span class="tooltipContent">Высокая вероятность подтверждения бронирования отеля</span></i>\n				';
 } 
__p+='\n			';
 } 
__p+='\n			</div>\n			<div class="serpHotelCard__info">\n                <div class="serpHotelCard__wrapper">\n					<div class="serpHotelCard__stars">\n						';

						var stars = category.get('stars');
						var categoryName = category.get('name');
						if(stars > 0) { for(var i=0;i< stars;i++) { 
__p+='\n						<i class="icon icon-i16_star"></i>\n						';

						}
						} else if(categoryName){
__p+='\n						<span>'+
((__t=( categoryName ))==null?'':__t)+
'</span>\n						';
 }
__p+='\n                    </div>\n                    <span class="serpHotelCard__renovation-date">'+
((__t=( dateOfLastHotelChange ))==null?'':__t)+
'</span>\n                </div>\n                <a href="#" class="serpHotelCard__title goToHotel">'+
((__t=( name ))==null?'':__t)+
'<span class="serpHotelCard__title-blur"></span></a>\n				<a href="#" class="serpHotelCard__resort goToHotel distance">\n					<i class="icon-i16_location2"></i>\n					'+
((__t=( resortName ))==null?'':__t)+
'\n				</a>\n			</div>\n			<div class="serpHotelCard__attributes">\n				';

				var placesLeft = 4,beachIcon;
				if(beachLine) {
				placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon-i16_water"></i> '+
((__t=( beachLine ))==null?'':__t)+
'-я линия\n					</div>\n				';
 } 
__p+='\n				';
 if (sandBeach) {
					beachIcon = {
						icon: 'sand',
						title: 'песок'
					};
				} else if (sandPebbleBeach) {
					beachIcon = {
						icon: 'sand_pebble',
						title: 'песок, галька'
					};
				} else if (pebbleBeach) {
					beachIcon = {
						icon: 'pebble',
						title: 'галька'
					};
				} 
__p+='\n				';
 if(beachIcon) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon-i16_beach_'+
((__t=( beachIcon.icon ))==null?'':__t)+
'"></i> <span>'+
((__t=( beachIcon.title ))==null?'':__t)+
'</span>\n						';
 if (beachDescription) { 
__p+='\n						<div class="tooltip">\n							<div class="serpHotelCard__tooltip-icon">?</div>\n							<div class="tooltip__container">'+
((__t=( beachDescription ))==null?'':__t)+
'</div>\n						</div>\n						';
 } 
__p+='\n					</div>\n				';
 } 
__p+='\n				';
 if (airConditioner) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon-i16_air-conditioning"></i> <span>кондиционер</span>\n						';
 if (conditionerDescription) { 
__p+='\n						<div class="tooltip">\n							<div class="serpHotelCard__tooltip-icon">?</div>\n							<div class="tooltip__container">'+
((__t=( conditionerDescription ))==null?'':__t)+
'</div>\n						</div>\n						';
 } 
__p+='\n					</div>\n				';
 } 
__p+='\n				';
 if (wifi) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon-i16_wifi"></i> <span>wi-fi</span>\n						';
 if (wifiDescription) { 
__p+='\n						<div class="tooltip">\n							<div class="serpHotelCard__tooltip-icon">?</div>\n							<div class="tooltip__container">'+
((__t=( wifiDescription ))==null?'':__t)+
'</div>\n						</div>\n						';
 } 
__p+='\n					</div>\n				';
 } 
__p+='\n				';
 if (nearTheBeach && placesLeft > 0) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon icon-i16_water"></i><span>Близко к пляжу</span>\n						';
 if (nearTheBeachDescription) { 
__p+='\n						<div class="tooltip">\n							<div class="serpHotelCard__tooltip-icon">?</div>\n							<div class="tooltip__container">'+
((__t=( nearTheBeachDescription ))==null?'':__t)+
'</div>\n						</div>\n						';
 } 
__p+='\n					</div>\n				';
 } 
__p+='\n				';
 if (nearTheLift && placesLeft > 0) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon icon-i16_lift"></i><span>Близко к подъемнику</span>\n						';
 if (nearTheLiftDescription) { 
__p+='\n							<div class="tooltip">\n								<div class="serpHotelCard__tooltip-icon">?</div>\n								<div class="tooltip__container">'+
((__t=( nearTheLiftDescription ))==null?'':__t)+
'</div>\n							</div>\n						';
 } 
__p+='\n					</div>\n				';
 } 
__p+='\n				';
 if (nearTheCenter && placesLeft > 0) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon icon-i16_city"></i><span>Близко к центру</span>\n						';
 if (nearTheCenterDescription) { 
__p+='\n							<div class="tooltip">\n								<div class="serpHotelCard__tooltip-icon">?</div>\n								<div class="tooltip__container">'+
((__t=( nearTheCenterDescription ))==null?'':__t)+
'</div>\n							</div>\n						';
 } 
__p+='\n					</div>\n				';
 } 
__p+='\n				';
 if (withKids && placesLeft > 0) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon icon-i16_children"></i><span>Отдых с детьми</span>\n						';
 if (withKidsDescription) { 
__p+='\n							<div class="tooltip">\n								<div class="serpHotelCard__tooltip-icon">?</div>\n								<div class="tooltip__container">'+
((__t=( withKidsDescription ))==null?'':__t)+
'</div>\n							</div>\n						';
 } 
__p+='\n					</div>\n				';
 } 
__p+='\n				';
 if (forCouples && placesLeft > 0) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon icon-i16_hotel_pair"></i><span>Идеально для пар</span>\n					</div>\n				';
 } 
__p+='\n				';
 if (adultsOnly && placesLeft > 0) {
					placesLeft--;
				
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon icon-i16_hotel_16plus"></i><span>Только для взрослых</span>\n					</div>\n				';
 } 
__p+='\n				';
 if (wellness && placesLeft > 0) {
__p+='\n					<div class="serpHotelCard__attribute">\n						<i class="icon icon-i16_beauty"></i><span>Оздоровительные туры</span>\n					</div>\n				';
 } 
__p+='\n			</div>\n		</div>\n		<div class="serpHotelCard__right">\n			<div class="serpHotelCard__right-block">\n				<div>\n					';
 if(ordersCount > 0) { 
__p+='\n					<div class="serpHotelCard__ordersCount">\n						Забронировано '+
((__t=(ordersCount ))==null?'':__t)+
' раз'+
((__t=(ordersCount.wordEnding(';а;') ))==null?'':__t)+
' <br> за месяц\n					</div>\n					';
 } 
__p+='\n				</div>\n				<div class="serpHotelCard__criteria">\n					'+
((__t=( touristGroup.adults ))==null?'':__t)+
' взросл'+
((__t=( touristGroup.adults.wordEnding("ый;ых;ых") ))==null?'':__t)+
'\n					';

					if(touristGroup.kids > 0) { 
__p+='\n						и '+
((__t=( (touristGroup.kids + touristGroup.infants) + " " + (touristGroup.kids + touristGroup.infants).wordEnding("ребенок;детей;детей") + "," ))==null?'':__t)+
'\n					';
 } else if(touristGroup.infants > 0) { 
__p+='\n						и '+
((__t=( touristGroup.infants + " " + touristGroup.infants.wordEnding("младенец;младенца;младенца") + "," ))==null?'':__t)+
'\n					';
 } 
__p+='\n					<br>\n					';

					var checkIndDate = moment(hotelOffer.get("checkInDate"),'YYYY-MM-DD').format("DD MMMM");
					var nights = hotelOffer.get('nights'),
					nightsStr = " на " + nights + " ноч" + nights.wordEnding("ь;и;ей;");
					
__p+='\n					'+
((__t=( 'c ' + checkIndDate + nightsStr))==null?'':__t)+
'\n				</div>\n			</div>\n			<a href="" class="serpHotelCard__btn">\n				';
 if(discount && discount > 0.1) { 
__p+='\n				<span class="serpHotelCard__btn-discount">'+
((__t=( hotelOffer.get('maxHistoricalPrice').formatNumber() ))==null?'':__t)+
' руб.</span>\n				';
 } 
__p+='\n				<span class="serpHotelCard__btn-price">\n					от <span>'+
((__t=( hotelOffer.get("price").formatNumber() ))==null?'':__t)+
'</span> руб.\n				</span>\n			</a>\n		</div>\n	</div>\n\n    <div class="cashbackPartialPayment__banner"></div>\n	<div class="partialPayment__banner"></div>\n	<div class="freeCancellation__banner"></div>\n</div>\n';
}
return __p;
};
